import { useMemo } from 'react'
import { useParams } from 'react-router-dom'
import { find } from 'lodash-es'
import { useQuery } from '@tanstack/react-query'
import { getSnowLoads } from '@queries'
import useSlabIconFromCenter from './useSlabIconFromCenter'

interface Arguments {
  slab: ShapeObject
  offset?: number
}

const useSnowLoadAssignment = ({ slab, offset = 0.05 }: Arguments) => {
  const { projectId }: { projectId?: string } = useParams()
  const { data: snowLoadsData } = useQuery(getSnowLoads.getKey(projectId), () =>
    getSnowLoads.request(projectId),
  ) as { isFetching: boolean; data?: SnowLoadConfiguration[] }

  const { pointForIcon, rotation } = useSlabIconFromCenter(slab, {
    offsetZ: offset,
    iconSizeX: 0.15,
    iconSizeY: 0.15,
    offsetX: 0.3,
  })

  return useMemo(() => {
    const hasSnowLoad = !!find(snowLoadsData, { element_guid: slab.guid })

    return {
      hasSnowLoad: hasSnowLoad,
      pointForIcon,
      rotation,
    }
  }, [snowLoadsData, slab.guid, pointForIcon, rotation])
}

export default useSnowLoadAssignment
